export default __webpack_public_path__ + "static/media/glass_mirror.64f81b0c.JPG";